import React from 'react';
import './Impact.css';

const Impact = () => {
  const stats = [
    { number: '10+', label: 'Students Benefited Since 2014' },
    { number: '5+', label: 'Currently Supporting Students' },
    { number: '100%', label: 'Transparency in Fund Usage' }
  ];

  const testimonials = [
    {
      icon: '🌸',
      quote: 'Thanks to Ezhuthaani.org, I was able to complete my under graduation degree and now I am supporting my family.',
      name: 'Usha, Under Graduate'
    },
    {
      icon: '⭐',
      quote: 'The scholarship helped me focus on studies instead of worrying about fees. Now I have completed my degree and working in a great company.',
      name: 'Hari, Software Engineer'
    },
    {
      icon: '🏆',
      quote: 'Ezhuthaani.org made my dream come true! I graduated from a prestigious engineering college in Tamil Nadu and now I am proudly supporting my family while building my career.',
      name: 'Santhosh, Engineering Graduate'
    },
    {
      icon: '📚',
      quote: 'With Ezhuthaani.org\'s support, I am currently pursuing my graduation degree with confidence. Their guidance has given me hope for a bright future.',
      name: 'Abhimanyu, Current Student'
    }
  ];

  return (
    <section className="impact" id="impact">
      <div className="container">
        <h2>Making a Tangible Difference</h2>
        
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className="stat-card">
              <div className="stat-number">{stat.number}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
        
        <div className="testimonials">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-icon">{testimonial.icon}</div>
              <blockquote>"{testimonial.quote}"</blockquote>
              <cite>- {testimonial.name}</cite>
            </div>
          ))}
        </div>
        
        <div className="cta-center">
          <a href="#stories" className="btn btn-secondary">See Our Impact Stories</a>
        </div>
      </div>
    </section>
  );
};

export default Impact;